export default "__VITE_ASSET__DtOCsiSm__"